module.exports = __webpack_public_path__ + "static/img/MO.f70d6657.jpg";